import { UseTarget } from 'components/pages/Planner/PlannerSections/components/TargetsPanel/TargetsPanel.types';
import TargetSection from 'components/pages/Planner/PlannerSections/TargetSection';
import { TargetType } from 'components/pages/Planner/PlannerSections/TargetSection/TargetSection.types';
import SectionDivider from 'components/pages/Planner/SectionDivider';
import { TargetLabel } from 'consts/targetLabel';
import { SelectionPermission } from 'store/productManagement/reducer.types';
import { definedRangePermissionOptions as permissionOptions } from '../../consts';
import { isValueRequired } from '../../utils/isValueRequired';
import SelectionPermissionDropdown from '../SelectionPermissionDropdown/SelectionPermissionDropdown';

type ProductTargetSectionProps = {
  dataTestId: string;
  icon?: string;
  label: TargetLabel;
  permissionSetter: (permission: { code: SelectionPermission; name: string }) => void;
  selectedPermission: { code: SelectionPermission; name: string };
  target: UseTarget;
  targetType: TargetType;
  title: string;
};

export const ProductTargetSection: React.FC<ProductTargetSectionProps> = ({
  dataTestId,
  icon,
  label,
  permissionSetter,
  selectedPermission,
  target,
  targetType,
  title,
}) => {
  return (
    <div className="border border-solid border-neutral-300 p-2 mb-2 rounded-md">
      <SelectionPermissionDropdown
        dataTestId={dataTestId}
        label={title}
        permissionOptions={permissionOptions}
        selectedPermission={selectedPermission}
        setSelectedPermission={permissionSetter}
      />
      {isValueRequired(selectedPermission.code) && (
        <>
          <SectionDivider spaceY={4} />
          <TargetSection
            icon={icon}
            isRange={selectedPermission.code === SelectionPermission.RANGE_VALUE}
            label={label}
            target={target}
            targetType={targetType}
          />
        </>
      )}
    </div>
  );
};
